let api = 'https://api.docircuit.org:3001';

// 설정파일을 개발자 모드에서는 .env.local 파일에서 가져옴
if( process.env.NODE_ENV!=='production') {
  if(process.env.REACT_APP_API !== undefined) {
    api = process.env.REACT_APP_API;
  }
}

export const loginState = {
  cid: "",
  mcd: "",
  level: "",
};

export const configState = {
    cid: '',
    name: '두써킷 관리자',
    api:api
}

export const start_hour = [
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
];

export const end_hour = [
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
  '24:00'
];